export const PROJECT_LINKS = {
    source:
        'https://github.com/oncekiyazilimci/2026-yazilim-sektoru-maaslari',
    github: 'https://github.com/egeaksoy00',
    linkedin: 'https://www.linkedin.com/in/egeaksoy00/',
    email: 'egeaksoy@ug.bilkent.edu.tr',
} as const;
